import React from 'react';
import classNames from 'classnames';
import { motion, AnimatePresence } from 'motion/react';
import { Link, navigate } from 'gatsby';

export const SubmenuLink = ({ children, link }) => (
  <Link to={link} className="h-full">
    <motion.div
      className={classNames(
        'relative mx-0.5 flex h-full cursor-pointer items-center px-3 py-2 text-sm font-medium',
        'after:absolute after:-bottom-0.5 after:left-0 after:h-0.5 hover:text-azure-800 hover:after:w-full hover:after:bg-azure-800'
      )}
    >
      {children}
    </motion.div>
  </Link>
);

export const SubmenuButton = ({ children, isOpen, onHover, onLeave }) => (
  <motion.div
    className={classNames(
      'relative mx-0.5 flex h-full cursor-pointer items-center px-3 py-2',
      'after:absolute after:-bottom-0.5 after:left-0 after:h-0.5',
      {
        'text-azure-800 after:w-full after:bg-azure-800': isOpen,
      }
    )}
    onClick={() => {
      if (children === 'Case Studies') {
        navigate('/case-studies');
      }
    }}
    onMouseEnter={onHover}
    onMouseLeave={onLeave}
  >
    <button className="flex items-center gap-2 text-sm font-medium">
      {children}
      <span
        className={classNames('transition-transform duration-300', {
          '-rotate-180': isOpen,
          'rotate-0': !isOpen,
        })}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="9"
          height="6"
          viewBox="0 0 9 6"
          fill="none"
        >
          <path
            className={classNames({
              'stroke-azure-800': isOpen,
              'stroke-black': !isOpen,
            })}
            d="M1.5332 1.5L4.5332 4.5L7.5332 1.5"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </span>
    </button>
  </motion.div>
);

export const SubmenuFlyoutMenu = ({ isOpen, children, onHover, onLeave }) => (
  <AnimatePresence>
    {isOpen && (
      <motion.div
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -10 }}
        transition={{ type: 'tween', ease: 'easeOut', duration: 0.3 }}
        className="absolute left-0 top-12 -z-[1] w-screen border-y border-y-black/10 bg-white p-6"
        onMouseEnter={onHover}
        onMouseLeave={onLeave}
      >
        {children}
      </motion.div>
    )}
  </AnimatePresence>
);
